export default "__VITE_ASSET__CvWk1L1P__"